import { Controller } from "react-hook-form";
import SearchList from "./SearchList";
import FieldLabel from "./FieldLabel";

export default function DynamicSelectComp({ control, path, params, disabled, name, label, required, ...props }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SearchList
          {...field}
          {...props}
          initialShow={props?.initialShow}
          disabled={disabled}
          value={field.value ?? ""}
          isOptionEqualToValue={(option, value) => (option?.id ?? option?._id) === (value?.id ?? value?._id)}
          label={
            <FieldLabel
              label={label}
              required={required}
            />
          }
          params={{
            path: path,
            params: { ...params },
          }}
          onChange={(_, newValue) => {
            field.onChange(newValue);
          }}
        />
      )}
    />
  );
}
